export function normalizeHexColor(value) {
  if (value === null || value === undefined) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";
  return trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
}

export function isValidHexColor(value) {
  const v = normalizeHexColor(value);
  return /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(v);
}

export function readCssVarHex(varName) {
  try {
    if (typeof window === "undefined") return "";
    const raw = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue(varName);
    return normalizeHexColor(raw);
  } catch {
    return "";
  }
}

export function getDefaultBrandColours() {
  const primary = readCssVarHex("--cf-primary-color");
  const secondary = readCssVarHex("--cf-primary-dark-blue-color");
  return {
    primary_colour: primary || "#3538cd",
    secondary_colour: secondary || "#45489e",
  };
}

export function getColorForPicker(value, fallbackHex = "#3538cd") {
  const normalized = normalizeHexColor(value);
  if (/^#([0-9a-fA-F]{6})$/.test(normalized)) return normalized;
  if (/^#([0-9a-fA-F]{3})$/.test(normalized)) {
    const short = normalized.slice(1);
    return `#${short[0]}${short[0]}${short[1]}${short[1]}${short[2]}${short[2]}`.toLowerCase();
  }
  return fallbackHex;
}

export function getEffectiveBrandColours(orgDomainColours) {
  const defaults = getDefaultBrandColours();
  const primary = normalizeHexColor(orgDomainColours?.primary_colour || "");
  const secondary = normalizeHexColor(orgDomainColours?.secondary_colour || "");

  return {
    primary_colour:
      primary && isValidHexColor(primary) ? primary : defaults.primary_colour,
    secondary_colour:
      secondary && isValidHexColor(secondary)
        ? secondary
        : defaults.secondary_colour,
  };
}

